import { filterBettableFixtures } from "./bettingDeskHelpers";
import { countOpenMarkets } from "./bondPredictHelpers";
import { getP2PStatusCounts } from "./p2pHelpers";
import { isMatchStarted } from "./predictionHelpers";

const LIVE_WHEEL_STATUSES = new Set(["Active", "Locked"]);
const LIVE_CASINO_STATUSES = new Set(["Active"]);

export const countOpenHouses = (houses = []) =>
  houses.filter((house) => filterBettableFixtures(house?.fixtures || []).length > 0)
    .length;

export const countActiveP2P = (bets = []) => getP2PStatusCounts(bets).Active || 0;

export const countOpenPredictMarkets = (markets = [], pagination = null) => {
  const total = Number(pagination?.totalCount);
  if (Number.isFinite(total) && total >= 0 && markets.every((m) => m?.status === "OPEN")) {
    return total;
  }
  return countOpenMarkets(markets);
};

export const countLivePlayGames = (wheelGames = [], casinoGames = []) => {
  const wheel = wheelGames.filter((g) => LIVE_WHEEL_STATUSES.has(g?.status)).length;
  const spin = casinoGames.filter((g) => LIVE_CASINO_STATUSES.has(g?.status)).length;
  return wheel + spin;
};

export const countActiveTips = (community = [], ai = []) => {
  const isActive = (item) => !isMatchStarted(item?.fixture || item?.fixtureData);
  return community.filter(isActive).length + ai.filter(isActive).length;
};
